import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './footer.scss';

import logo from '../../assets/fake-data/logo';

const Footer = () => {

  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="footer__body ">
              <div className="f-img">
                <Link to="/">
                  <img src={logo} alt="Monteno" data-aos="fade-down" />
                </Link>
              </div>
              <p className="desc fs-19" data-aos="fade-up-text">
                Rodex Hostel
              </p>
              <p className="desc fs-18" data-aos="fade-up">
                Comodidad y encuentro en el centro de Tucumán.
              </p>
              <ul className="social">
                <li className="facebook" data-aos="fade-up" data-aos-duration="1000">
                  <a href="https://www.facebook.com/p/Rodex-Hostel-Boutique-61555503345777/" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li className="instagram" data-aos="fade-up" data-aos-duration="1200">
                  <a href="https://www.instagram.com/rodex.hosteltucuman/?hl=es-la" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
                <li className="tiktok" data-aos="fade-up" data-aos-duration="1400">
                  <a href="https://www.tiktok.com/@rodex.hostel.tucu" target="_blank" rel="noopener noreferrer">
                    <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" style={{ display: 'block' }}>
                      <title>TikTok</title>
                      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
                    </svg>
                  </a>
                </li>
                <li className="booking" data-aos="fade-up" data-aos-duration="1600">
                  <a href="https://www.booking.com/hotel/ar/hostel-boutique-rodex.es.html?aid=356980&label=gog235jc-10CAsoDEIVaG9zdGVsLWJvdXRpcXVlLXJvZGV4SCxYA2gMiAEBmAEzuAEXyAEM2AED6AEB-AEBiAIBqAIBuALGsb3QBsACAdICJDRjODRlNWE1LTg5ZDgtNGE5Yy05Y2ZmLTZmOTQwMjBmYjYzMdgCAeACAQ&sid=bb38fd1abef9b2496db812f0a0c4dcd6&dest_id=-1013611&dest_type=city&dist=0&group_adults=2&group_children=0&hapos=1&hpos=1&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&srepoch=1779390746&srpvid=2e068709ab30015c&type=total&ucfs=1&" target="_blank" rel="noopener noreferrer">
                    <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" style={{ display: 'block' }}>
                      <title>Booking.com</title>
                      <path d="M8.575 6.563h2.658c2.108 0 3.473 1.15 3.473 2.898 0 1.15-.575 1.82-.91 2.108l-.287.263.335.192c.815.479 1.318 1.389 1.318 2.395 0 1.988-1.51 3.257-3.857 3.257H7.449V7.713c0-.623.503-1.126 1.126-1.15zm1.7 1.868c-.479.024-.694.264-.694.79v1.893h1.676c.958 0 1.294-.743 1.294-1.365 0-.815-.503-1.318-1.318-1.318zm-.096 4.36c-.407.071-.598.31-.598.79v2.251h1.868c.934 0 1.509-.55 1.509-1.533 0-.934-.599-1.509-1.51-1.509zm7.737 2.394c.743 0 1.341.599 1.341 1.342a1.34 1.34 0 0 1-1.341 1.341 1.355 1.355 0 0 1-1.341-1.341c0-.743.598-1.342 1.34-1.342z" />
                    </svg>
                  </a>
                </li>

              </ul>
            </div>
            <div className="footer_bottom">
              <p className="fs-16">Copyright © 2026, Hostel Rodex - Designed by <Link to="https://georginabordoy.com">Croma Webs</Link></p>
              <ul>
                <li><Link to="#">Terms & Condition</Link></li>
                <li><Link to="#">Privacy Policy</Link></li>

              </ul>
            </div>
          </div>
        </div>
      </footer>
      {
        isVisible &&
        <Link onClick={scrollToTop} to='#' id="scroll-top"></Link>
      }</>

  );
}

export default Footer;